import { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getEvents } from '../../api/events';
import type { EventInfo } from '../../api/types';
import { EventCard } from '../../components/EventCard';
import { EmptyState } from '../../components/ui/EmptyState';
import { LoadingScreen } from '../../components/ui/LoadingScreen';
import { brand } from '../../app/config';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useUserData } from '../../hooks/useUserData';

export function HomePage() {
    useDocumentTitle();
    const navigate = useNavigate();
    const user = useUserData();

    const [events, setEvents] = useState<EventInfo[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        // La lista arriva già filtrata dal server (eventi in corso o da iniziare, max 10)
        getEvents()
            .then((list) => {
                if (active) setEvents(list);
            })
            .catch(() => {
                if (active) setEvents([]);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    return (
        <div className="flex flex-col gap-8">
            <section className="flex flex-col items-center gap-4 py-8 text-center">
                <img src={brand.logo} alt={`${brand.name} logo`} className="h-20 w-auto" />
                <div>
                    <Typography variant="h3" sx={{ fontWeight: 900 }}>
                        Prossimi <span className="text-accent">EVENTI</span>
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        {brand.tagline}
                    </Typography>
                </div>
                <Button
                    variant="contained"
                    size="large"
                    sx={{ borderRadius: 999, px: 5, py: 1.5, fontSize: '1.1rem', fontWeight: 900 }}
                    onClick={() => navigate(user.logged ? '/form' : '/login')}
                >
                    FAI UNA RICHIESTA!
                </Button>
            </section>

            {loading ? (
                <LoadingScreen />
            ) : events.length === 0 ? (
                <EmptyState message="Non ci sono ancora eventi in programma." />
            ) : (
                <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {events.map((event) => (
                        <EventCard key={event.event_id} event={event} />
                    ))}
                </section>
            )}
        </div>
    );
}
